function exist($place){if($($place).length) {return true;}}
$html = $("html");
if(exist(".login")) {
	$(".navigation-buttons").prepend(
		'<span class="pkHeader pkUser"><a href="/login/"><span>Přihlášení</span></a></span>'
	);
} else {
	$(".navigation-buttons").prepend(
		'<span class="pkHeader pkUser"><a href="/klient/"><span>Můj účet</span></a></span>'
	);
}

$(".navigation-buttons").prepend(
	'<span class="pkHeader pkHeaderPhone"><span>tel.: </span><a href="tel:+420558323742"><span>+420 </span>558 323 742</a></span>'
);

$(".navigation-buttons").prepend(
	'<span class="pkHeader pkHeaderCountry">'+
		'<div class="pkCountrySelected"><a href="#">CZ</a></div>'+
		'<div class="pkCountrySelect">'+
			'<a href="/" class="pkCountryButton">CZ</a>'+
			'<a href="https://www.unipack.sk" class="pkCountryButton">SK</a>'+
		'</div>'+
	'</span>'
);

$html.on("click", ".pkCountrySelected", function(e) {
	e.preventDefault();
	$(".pkCountrySelect").toggleClass("active");
})

$html.on("mouseup", function (e) {
	if(exist(".pkCountrySelect.active")) {
		if (!$(".pkCountrySelect").is(e.target) && $(".pkCountrySelect").has(e.target).length === 0) {
			$(".pkCountrySelect").removeClass("active");
		}
	}
})


var pkNavi1text = $.trim($("#navigation-1").text());
if(pkNavi1text.indexOf("/") != -1) {
	pkNavi1text = $.trim(pkNavi1text.replace("/", ""));
}
if(exist(".pkSidebar-odkazy")) {
	$(".pkSidebar-odkazy ul li a").filter(function() {
		return pkNavi1text == $(this).text() || pkNavi1text == $(this).data("name");
	}).addClass("active");
}




$html.on("click", ".filter-section h4", function() {
	$(this).toggleClass("active");
})





if(exist("#footer")) {
	$("#footer #signature").remove();
	$("#footer .copyright").prepend(
		'<div class="pkSocial">'+
			'<a href="https://www.youtube.com/user/UNIPACKcz" class="pkYt"><span class="sr-only">YouTube</span></a>'+
			'<a href="https://www.facebook.com/UNIPACKbalicisystemy" class="pkFb"><span class="sr-only">Facebook</span></a>'+
		'</div>'
	).append(' <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Vytvořil Shoptet" class="title" target="_blank">Vytvořil Shoptet</a>');
}




$(".footer-banners .footer-banner:not(:last-child)").wrapAll("<div class='footer-slider' />");
$(".footer-slider").slick({
	autoplay: true,
	autoplaySpeed: 4000
});



if(exist("#footer")) {
	pkBlogLink = '/aktuality/';
	if(exist(".id-1")) {
		$("#footer").before(
			'<div id="pkBlog">'+
				'<div class="container">'+
					'<div class="h4 homepage-group-title">Aktuality</div>'+
					'<div class="pkBlog news-wrapper"></div>'+
				'</div>'+
			'</div>'
		);
	} else if(!exist(".id-1017")) {
		$("#content").append(
			'<div id="pkBlog">'+
				'<div class="h4 homepage-group-title">Aktuality</div>'+
				'<div class="pkBlog news-wrapper"></div>'+
			'</div>'
		);
	}
	if(sessionStorage.pkBlog) {
		$(".pkBlog").append(sessionStorage.pkBlog);
	} else {
		$.ajax({
			type: 'GET',
			dataType: 'html',
			timeout: 1000,
			url: pkBlogLink,
			success: function(pkAktuality) {
				var pkRequestedDocument = shoptet.common.createDocumentFromString(pkAktuality);

				var htmlWrapper = "";
				var pkAkt = $(pkRequestedDocument).find('#newsWrapper .news-item').each(function(x) {
					if(x > 1) return;
					$(this).find('img').each(function() {
						var dataSrc = $(this).attr('data-src');
						if (dataSrc) {
							$(this).attr('src', dataSrc);
						}
					});
					htmlWrapper += $(this)[0].outerHTML;
				});

				if (pkAkt !== null) {
					$(".pkBlog").append(htmlWrapper);
					sessionStorage.pkBlog = htmlWrapper;
				}
				
				if(exist(".news-wrapper")) {
					$(".news-wrapper .news-item").each(function() {
						$this = $(this);
						$thisHref = $this.find("a").attr("href");
						$this.find(".text").append('<a href="' + $thisHref + '" class="pkZjistitVice">Zjistit více</a>');
					})
				}
			}
		})
	}
}

if(exist(".news-wrapper")) {
	$(".news-wrapper .news-item").each(function() {
		$this = $(this);
		$thisHref = $this.find("a").attr("href");
		$this.find(".text").append('<a href="' + $thisHref + '" class="pkZjistitVice">Zjistit více</a>');
	})
}



if(exist(".type-product")) {
	$(".link-icon.chat").removeClass("chat").addClass("pkChat");

	if(exist("#productVideos")) {
		if(exist(".p-thumbnail")) {
			createThumbnails();
		} else {
			pkMainImageHref = $(".p-main-image").attr("href")
			if(pkMainImageHref.indexOf("/big/")) {
				pkMainImageHrefRel = pkMainImageHref.replace("big", "related");
			}
			$(".p-image-wrapper .p-image").after(
				'<div class="p-thumbnails-wrapper">'+
					'<div class="p-thumbnails p-thumbnails-horizontal">'+
						'<div class="p-thumbnails-inner">'+
							'<div>'+
								'<a href="' + pkMainImageHref + '" class="p-thumbnail highlighted">'+
									'<img data-src="' + pkMainImageHrefRel + '" width="100" height="100">'+
								'</a>'+
								'<a href="' + pkMainImageHref + '" class="cbox-gal cboxElement" data-gallery="lightbox[gallery]"></a>'+
							'</div>'+
						'</div>'+
						'<a href="#" class="thumbnail-prev"></a>'+
						'<a href="#" class="thumbnail-next"></a>'+
					'</div>'+
				'</div>'
			);
			createThumbnails();
		}
	}
	if(exist("#variants")) {
		$(".shp-tab-link[href='#description']").parent().prependTo("#p-detail-tabs");
		$(".variant-name").each(function() {
			if($(this).text().indexOf(",") != -1) {
				wrapText = $(this).text().split(",")[0];
				lastText = $(this).text().split(",")[1];
				if(wrapText.indexOf("Kód: ") != -1) {
					$(this).html('<strong>' + wrapText + '</strong>, ' + lastText);
				} else {
					if($(this).parent().text().indexOf("|") != -1) {
						pkCode = $(this).parent().text().split("|")[1].split("\n")[0].trim();
						$(this).prepend('<strong>' + pkCode + '</strong> ');
					}
				}
			} else {
				if($(this).parent().text().indexOf("|") != -1) {
					pkCode = $(this).parent().text().split("|")[1].split("\n")[0].trim();
					$(this).prepend('<strong>' + pkCode + '</strong> ');
				}
			}

		})
	}

	if(exist("#product-detail-form meta[itemprop='price'][content='0.00']")) {
		$("body").addClass("pkDisabled");
		$(".price-final-holder").text("Na dotaz");
		$(".price-additional").text("");
		$(".social-buttons-wrapper").appendTo(".p-image-wrapper");
		$(".p-info-wrapper .availability-value").remove();
		$(".p-info-wrapper .detail-parameters").remove();
		$(".add-to-cart").html("<a href='#' class='btn btn-primary pkSendRequest'>Odeslat poptávku</a>");
		if(exist("#variants")) {
			$(".variant-table .price").remove();
			$(".variant-table .cart").remove();
			$(".variant-table span").remove();
			$(".p-final-price-wrapper + p").html("<a href='#' class='btn btn-primary pkSendRequest'>Odeslat poptávku</a>");
		}
		$(".p-info-wrapper").append(
			'<div class="pkProdejci">'+
				'<h4>Kontaktujte svého prodejce:</h4>'+
				'<div class="pkProdejciHelper hide noDisplayno-display" />'+
				'<div class="pkProdejciSelect">'+
					'<span>Vyberte svůj region</span>'+
					'<select></select>'+
				'</div>'+
				'<div class="pkProdejce"></div>'+
			'</div>'
		);
		if(sessionStorage.pkProdejciV1) {
			$(".pkProdejciHelper").html(sessionStorage.pkProdejciV1);
			pkProdejciOptions();
		} else {
			$(".pkProdejciHelper").load("/kontakty/ #pkProdejci table", function() {
				sessionStorage.pkProdejciV1 = $(".pkProdejciHelper").html();
				pkProdejciOptions();
			})
		}
	}

	if(exist("#relatedFiles")) {
		$(".shp-tab-link[href='#relatedFiles']").text("Související soubory");
		if(exist("#relatedFiles a[title='Stáhnout prospekt']")) {
			$("#relatedFiles a[title='Stáhnout prospekt']").addClass("link-icon pdf").clone().appendTo(".social-buttons-wrapper .link-icons");
			$("#relatedFiles a[title='Stáhnout prospekt']").parent().remove();

			if(!$("#relatedFiles li").length) {
				$(".shp-tab-link[href='#relatedFiles']").parent().remove();
			}
		}
	}

	$(".p-detail").addClass("loaded");
}
/*
function createThumbnails() {
	$("#productVideos iframe:first-of-type").clone().insertAfter(".p-thumbnail:first + a").wrap('<a class="p-thumbnail pkVideo" href="#pkVideo" />');
	$(".pkVideo iframe").before('<div class="iframe-overlay"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00" fill-opacity="1"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></div>');
	pkVideoSrc = $(".pkVideo iframe").attr("src");
	pkVideoSrc = pkVideoSrc.split("embed/")[1].split("?rel")[0];
	pkVideoBg = "url(https://img.youtube.com/vi/" + pkVideoSrc + "/0.jpg)";
	$(".iframe-overlay").css("background-image", pkVideoBg);
}
*/



function createThumbnails() {
	$("#productVideos iframe").each(function() {
		var cloned = $(this).clone();

		cloned.insertAfter(".p-thumbnail:first + a").wrap('<a class="p-thumbnail pkVideo" href="#pkVideo" />');
		cloned.before('<div class="iframe-overlay"><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00" fill-opacity="1"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></div>');
		var pkVideoSrc = cloned.attr("data-iframe-src");
		$(this).attr('src' , pkVideoSrc)
		pkVideoSrc = pkVideoSrc.split("embed/")[1].split("?rel")[0];
		var pkVideoBg = "url(https://img.youtube.com/vi/" + pkVideoSrc + "/0.jpg)";		
		cloned.parent(".pkVideo").find(".iframe-overlay").css("background-image", pkVideoBg);
		cloned.parent(".pkVideo").find("iframe").attr("src", $(this).attr("data-iframe-src"));
	});
}

$html.on("change", ".pkProdejciSelect select", function() {
	pkProdejceSelecting($(this))
})

function pkProdejceSelecting($el) {
	pkSelectedProdejce = $el.find(":selected").text();
	$(".pkProdejce").html($(".pkProdejciHelper td h3").filter(function() {
		return $(this).text() == pkSelectedProdejce;
	}).closest("td").html());
}

function pkProdejciOptions() {
	$(".pkProdejciHelper td h3.czProdejce").each(function() {
		$(this).clone().appendTo(".pkProdejciSelect select").wrap('<option />');
	});
	pkProdejceSelecting($(".pkProdejciSelect select"));
}

$html.on("click", ".pkVideo .iframe-overlay", function(e) {
	pkPopupContent = $(this).closest(".pkVideo").html();
	pkOverlay();
	pkPopup(pkPopupContent, "pkPopupVideo");
	$(".pkPopup iframe").attr("src", $(".pkPopup iframe").attr("src") + "&autoplay=1");
	$(this).closest('iframe').attr('style', 'position:absolute;z-index:2;border:0;')
	return false;
})

$html.on("click", ".pkChat", function(e) {
	e.preventDefault();
	pkPopupContent = 
	'<div class="pkFormular">'+
	'<h2>Dotaz na prodejce</h2>'+
	'<form id="formContact" action="/action/MailForm/sendProductQuestion/" method="post" id="formProductQuestion" class="poptavka-form">'+
		'<fieldset>'+
		'<div class="pkFormularIn">'+
			'<div class="pkFormularIn-left">'+
				'<input name="formId" type="hidden" value="10" />'+
				'<input type="hidden" name="productId" value="' + $("#product-detail-form input[name='productId']").attr("value") + '">'+
				'<div class="form-group"><label for="fullName">Vaše jméno a příjmení:</label> <input id="fullName" class="form-control" name="fullName" required="" type="text" value="" /> <span class="no-display">Nevyplňujte toto pole:</span> <input class="no-display" name="surname" type="text" value="" /></div>'+
				'<div class="form-group"><label for="firm">Firma:</label> <input id="firm" class="form-control" name="firm" required="" type="text" value="" /></div>'+
				'<div class="form-group"><label for="pobocka">Pobočka:</label> <input id="pobocka" class="form-control" name="pobocka" type="text" value="" /></div>'+
				'<div class="form-group"><label for="email">Váš e-mail:</label> <input id="email" class="form-control" name="email" required="" type="email" value="" /></div>'+
				'<div class="form-group"><label for="phone">Telefon:</label> <input id="phone" class="form-control" name="phone" required="" type="text" value="" /></div>'+
			'</div>'+
			'<div class="pkFormularIn-right">'+
				'<div class="form-group"><label for="region">Region:</label> <select required=""><option value="Moravskoslezský kraj">Moravskoslezský kraj</option><option value="Jižní Morava">Jižní Morava</option><option value="Střední Čechy, Praha">Střední Čechy, Praha</option><option value="Jižní Čechy">Jižní Čechy</option><option value="Severní Čechy">Severní Čechy</option><option value="Východní Čechy">Východní Čechy</option></select></div>'+
				'<div class="form-group"><label for="message">Váš vzkaz:</label> <textarea class="form-control" name="message" required="" rows="7"></textarea></div>'+
				'<div class="form-group consents consents-first"><input id="consents40" name="consents[]" type="hidden" value="40" data-special-message="validatorConsent" /> <label class="whole-width" for="consents40">Vaše data jsou u nás v bezpečí. <a href="/podminky-ochrany-osobnich-udaju/" target="_blank" rel="noopener noreferrer">Podmínky zpracování osobních údajů</a> </label></div>'+
			'</div>'+
			'<div class="form-group submit-wrapper"><input class="btn btn-primary" type="submit" value="Odeslat poptávku" /></div>'+
		'</div>'+
		'</fieldset>'+
	'</form>'+
	'</div>';

	pkOverlay();
	pkPopup(pkPopupContent);
	
})



$html.on("click", ".pkSendRequest", function(e) {
	e.preventDefault();
	pkPopupContent = 
	'<div class="pkFormular">'+
	'<h2>Poptávka produktu ' + $(".p-detail meta[itemprop='name']").attr("content") + '</h2>'+
	'<form id="formContact" action="/action/MailForm/sendProductQuestion/" method="post" id="formProductQuestion" class="poptavka-form">'+
		'<fieldset>'+
		'<div class="pkFormularIn">'+
			'<div class="pkFormularIn-left">'+
				'<input name="formId" type="hidden" value="10" />'+
				'<input type="hidden" name="productId" value="' + $("#product-detail-form input[name='productId']").attr("value") + '">'+
				'<div class="form-group"><label for="fullName">Vaše jméno a příjmení:</label> <input id="fullName" class="form-control" name="fullName" required="" type="text" value="" /> <span class="no-display">Nevyplňujte toto pole:</span> <input class="no-display" name="surname" type="text" value="" /></div>'+
				'<div class="form-group"><label for="firm">Firma:</label> <input id="firm" class="form-control" name="firm" required="" type="text" value="" /></div>'+
				'<div class="form-group"><label for="pobocka">Pobočka:</label> <input id="pobocka" class="form-control" name="pobocka" type="text" value="" /></div>'+
				'<div class="form-group"><label for="email">Váš e-mail:</label> <input id="email" class="form-control" name="email" required="" type="email" value="" /></div>'+
				'<div class="form-group"><label for="phone">Telefon:</label> <input id="phone" class="form-control" name="phone" required="" type="text" value="" /></div>'+
			'</div>'+
			'<div class="pkFormularIn-right">'+
				'<div class="form-group"><label for="region">Region:</label> <select required=""><option value="Moravskoslezský kraj">Moravskoslezský kraj</option><option value="Jižní Morava">Jižní Morava</option><option value="Střední Čechy, Praha">Střední Čechy, Praha</option><option value="Jižní Čechy">Jižní Čechy</option><option value="Severní Čechy">Severní Čechy</option><option value="Východní Čechy">Východní Čechy</option></select></div>'+
				'<div class="form-group"><label for="message">Váš vzkaz:</label> <textarea class="form-control" name="message" required="" rows="7"></textarea></div>'+
				'<div class="form-group consents consents-first"><input id="consents40" name="consents[]" type="hidden" value="40" data-special-message="validatorConsent" /> <label class="whole-width" for="consents40">Vaše data jsou u nás v bezpečí. <a href="/podminky-ochrany-osobnich-udaju/" target="_blank" rel="noopener noreferrer">Podmínky zpracování osobních údajů</a> </label></div>'+
			'</div>'+
			'<div class="form-group submit-wrapper"><input class="btn btn-primary" type="submit" value="Odeslat poptávku" /></div>'+
		'</div>'+
		'</fieldset>'+
	'</form>'+
	'</div>';

	pkOverlay();
	pkPopup(pkPopupContent);
})

$("html").on("submit", ".poptavka-form", function() {
    var originalRemark = $('.poptavka-form textarea.form-control').val();
    var mhregion = $('.poptavka-form select').find(":selected").val();
	var mhfirma = $('input#firm').val();
	var mhpobocka = $('input#pobocka').val();
    var pkNewRemark = 'Firma: '+mhfirma+'------\nPobočka: '+mhpobocka+'------\nRegion: ' + mhregion+ ' ------\nZpráva: '+originalRemark;
    $(".poptavka-form textarea.form-control").val(pkNewRemark);
	console.log('odeslána poptávka')
});

$html.on("click", ".pkPopupClose", function() {
	pkOverlayRemove();
	pkPopupRemove();
})

$(document).mouseup(function (e) {
	if (!$(".pkPopupContent").is(e.target) && $(".pkPopupContent").has(e.target).length === 0) {
		pkOverlayRemove();
		pkPopupRemove();
	}
});

function pkPopup(content, mainClass) {
	if(!mainClass) {
		mainClass = "";
	}
	$("body").append('<div class="pkPopup ' + mainClass + '"><div class="pkPopupIn"><div class="pkPopupClose" title="Zavřít"/><div class="pkPopupContent">' + content + '</div></div></div>');
}

function pkPopupRemove() {
	$('.pkPopup').remove();
}

function pkOverlay(mainClass) {
	if(!mainClass) {
		mainClass = "";
	}
	$("body").append('<div class="pkOverlay ' + mainClass  + '" />');
}

function pkOverlayRemove() {
	$('.pkOverlay').remove();
}




if(exist(".columns-3 .products")) {
	$("body").removeClass("columns-3").addClass("columns-4");
}



if(exist(".products")) {
	$(document).on("ready ShoptetDOMContentLoaded", function() {
		$(".products .product").each(function() {
			$this = $(this);
			pkPrice = $this.find('div[data-micro="offer"]').data("micro-price");
			if(pkPrice == 0.00){
				$this.find(".prices").addClass("pkZero");
				$this.find('.ratings-wrapper .availability').hide()
			}
		})

		$(".products .product .prices").addClass("pkLoaded");
	})
}



if(exist(".pkResponzTable")) {
	$(".pkResponzTable").wrap('<div class="pkResponzTable-wrapper">');
	$("#content").addClass("pkOverflowHidden");
}



if(exist(".in-krok-2")) {
	if(localStorage.billOrderNumber) {
		billOrNr = localStorage.billOrderNumber
	} else {
		billOrNr = ""
	}

	$(".co-billing-address .box-bg-default > .form-group:last-child").after(
		'<div class="form-group">'+
			'<label for="billOrderNumber">'+
				'<span">Vaše číslo objednávky</span>'+
			'</label>'+
			'<input type="text" value="' + billOrNr + '" id="billOrderNumber" name="billOrderNumber" class="form-control">'+
		'</div>'
	)
	if(localStorage.orderSubmit) {
		$("#remark").val(localStorage.originalRemark);
		localStorage.orderSubmit = "";
		localStorage.originalRemark = "";
	}
}

$html.on("submit", "#order-form", function() {
	localStorage.orderSubmit = true;
	localStorage.originalRemark = $("#remark").val();
	pkBillOrderNr = $("#billOrderNumber").val();
	pkNewRemark = localStorage.originalRemark + '\n\nVASE_CISLO_OBJEDNAVKY:' + pkBillOrderNr;
	if(!$('#add-note:checked').length){
		$('#add-note').attr("checked", true);
	}
	$("#remark").val(pkNewRemark)
})


  //pro funkci je nutno mít modul minimální objednatelné množství

// Funkce pro přidání množství po násobcích
function addQuantityByMultiples(el, min, max, multiples, action) {
    var $amountInput = $(el).closest('.quantity').find('.amount');
    var value = parseFloat($amountInput.val());
    if (isNaN(value)) {
        return false;
    }
    var min = parseFloat(min);
    var max = parseFloat(max);
    var multiples = parseFloat(multiples);

    if (action === 'increase') {
        value += multiples;
    } else if (action === 'decrease') {
        value -= multiples;
    }
    if (value < min) {
        value = min;
    } else if (value > max) {
        value = max;
    }
    $amountInput.data('quantity', value);
    return true;
}
$('html').on('click', '.increase', function () {
    var min = $(this).closest('.quantity').find('.amount').data('min');
    var max = $(this).closest('.quantity').find('.amount').data('max');
    var multiples = min - 1;
    addQuantityByMultiples(this, min, max, multiples, 'increase');
});

$('html').on('click', '.decrease', function () {
    var min = $(this).closest('.quantity').find('.amount').data('min');
    var max = $(this).closest('.quantity').find('.amount').data('max');
    var multiples = min - 1;
    addQuantityByMultiples(this, min, max, multiples, 'decrease');
});

if($('.id--9').length){
	$('.quantity input.amount').attr('readonly','true');
}
$(document).on("ready ShoptetDOMCartContentLoaded", function() {
	$('.quantity input.amount').attr('readonly','true');
})
